/**
 * Group Icon Component
 * 
 * Displays musician-specific performance parameter icons with on/off states.
 */

import React from 'react';
import './Icon.css';

/**
 * Icon component for group parameters
 * 
 * @param {object} props - Component props
 * @param {boolean} props.isOn - Whether the parameter is active
 * @param {string} props.iconName - Name of the icon file (without extension)
 */
export function GroupIcon({ isOn, iconName }) {
  if (!iconName) return null;
  
  const className = isOn ? 'icon-on' : 'icon-off';
  const iconPath = `./${iconName}.svg`;
  
  return (
    <img
      className={className}
      src={iconPath}
      alt={`Icon ${iconName}`}
      style={{ objectFit: 'contain', imageRendering: '-webkit-optimize-contrast' }}
    />
  );
}


